export default __webpack_public_path__ + "static/media/gallery_01.44d51c01.jpg";